import React, { useEffect, useState } from "react";
import { MakeClassName } from "./MakeClassName";

const SwitchButton = ({
  toggleFunction,
  defaultStatus,
  selectedRow,
  keyFiled,
}) => {
  const [switchStatus, setSwitchStatus] = useState(defaultStatus);

  const toggleSwitch = () => {
    let newStatus = !switchStatus;
    toggleFunction(selectedRow, keyFiled, newStatus);
    setSwitchStatus(newStatus);
  };

  return (
    <label
      className={MakeClassName("switch", switchStatus === true && " active")}
      onClick={toggleSwitch}
    >
      <span className="slider round"></span>
    </label>
  );
};

export default SwitchButton;
